import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@reach/router';
import { I18N, EllipsisBox } from 'commons';

const ItemDetail = ({ textMessage, id }) => (
  <article className="description" eb-test="ee_notificationList_field_itemBody">
    <div className="description-content">
      <EllipsisBox text={textMessage} textClass="ellipsis-box" />
    </div>
  </article>
);

ItemDetail.propTypes = {
  id: PropTypes.string.isRequired,
  textMessage: PropTypes.string.isRequired,
};

export default ItemDetail;
